import { Inject, Injectable, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityService } from '@services/entity/entity.service';
import { StripeInfo } from '@models/stripeInfo';
import { Observable } from 'rxjs';
import { StripeInfoDto } from '@dto/stripeInfoDto';
import { __param } from 'tslib';

@Injectable({
  providedIn: 'root'
})
export class StripeInfosService extends EntityService {

  public entityRoute = "stripeInfos";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  createStripeInfoForUser(userId: string, stripeInfo: StripeInfo): Observable<StripeInfoDto> {
    return this.http.post<StripeInfoDto>(this.baseUrl + 'api/stripeInfos/user/' + userId, stripeInfo);
  }
  
  getStripeInfoOfUser(userId: string): Observable<StripeInfoDto> {
    return this.http.get<StripeInfoDto>(this.baseUrl + 'api/stripeInfos/user/' + userId);
  }

  getStripeInfoOfCustomer(customerId: number): Observable<StripeInfoDto> {
    return this.http.get<StripeInfoDto>(this.baseUrl + 'api/stripeInfos/customer/' + customerId);
  }

  getStripeInfo(id: number): Observable<StripeInfoDto> {
    return this.http.get<StripeInfoDto>(this.baseUrl + 'api/stripeInfos/' + id);
  }

  createStripeOnboardingUrl(userId: string, accountId: string): Observable<StripeInfoDto> {
    return this.http.get<StripeInfoDto>(this.baseUrl + 'api/stripeInfos/onboarding-url/' + userId + '/' + accountId);
  }

  createStripeDashboardUrl(userId: string, accountId: string): Observable<StripeInfoDto> {
    return this.http.get<StripeInfoDto>(this.baseUrl + 'api/stripeInfos/dashboard-url/' + userId + '/' + accountId);
  }

  static matches(stripe: StripeInfoDto, term: string, pipe?: PipeTransform) {
    return stripe.stripeCustomerId?.toLowerCase().includes(term.toLowerCase())
      || stripe.stripeAccountId?.toLowerCase().includes(term.toLowerCase())
      || stripe.stripeProductId?.toLowerCase().includes(term.toLowerCase())
  }
}
